<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item
                label="评价类型"
                prop="orderWorkCategoryType"
                style="width: 80%"
              >
                <el-select
                  v-model="searchForm.orderWorkCategoryType"
                  clearable filterable
                  placeholder="请选择类型"
                >
                  <el-option label="报事" :value="1"></el-option>
                  <el-option label="报修" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="工单编号"
                prop="orderWorkNo"
                style="width: 80%"
              >
                <el-input
                  v-model="searchForm.orderWorkNo"
                  placeholder="请输入工单编号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="物业管家"
                prop="manageUserName"
                style="width: 80%"
              >
                <el-input
                  v-model="searchForm.manageUserName"
                  placeholder="请输入物业管家"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="评价时间" prop="time" style="width: 80%">
                <el-date-picker
                  v-model="searchForm.time"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>                
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="评价等级" prop="score" style="width: 80%">
                <el-select
                  clearable filterable
                  v-model="searchForm.score"
                  placeholder="请选择评价等级"
                >
                  <el-option label="非常满意" :value="1"></el-option>
                  <el-option label="一般" :value="2"></el-option>
                  <el-option label="差评" :value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button
                size="small"
                @click="onLoad"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px"></div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="orderWorkNo" label="工单编号" align="center">
        </el-table-column>
        <el-table-column prop="userName" label="用户姓名" align="center">
        </el-table-column>
        <el-table-column prop="orderWorkName" label="工单名称" align="center">
        </el-table-column>
        <el-table-column prop="content" label="用户评价" align="center">
        </el-table-column>
        <el-table-column
          prop="score"
          label="评价等级"
          align="center"
          :formatter="typeList"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="orderWorkCategoryType"
          label="评价类型"
          align="center"
          :formatter="orderList"
        > -->
        </el-table-column>
        <el-table-column prop="createTime" label="评价时间" align="center">
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import reg from '../../utils/reg'
export default {
  data() {
    return {
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      tableData: [],
      isShowloading: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },      
      searchForm: {
        orderWorkCategoryType: "",
        orderWorkNo: "",
        time:''
      },
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    typeList(row) {
      if (row.score == 1) {
        return "非常满意";
      } else if (row.score == 2) {
        return "一般";
      } else if (row.score == 3) {
        return "差评";
      }
    },
    orderList(row) {
      if (row.score == 1) {
        return "报事";
      } else if (row.score == 2) {
        return "报修";
      }
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad(ind) {
      this.isShowloading = true;
      let {time,orderWorkNo,orderWorkCategoryType,manageUserName,score} = this.searchForm
      this.currentPage = ind == 1 ? 1 : this.currentPage 
      let page = {
        current: this.currentPage,
        size: this.pageSize,
        endTime:reg.filterTime(time[1]) || '',
        startTime:reg.filterTime(time[0]) || '',
        orderWorkNo,
        orderWorkCategoryType,
        manageUserName,
        score
      };
      this.tableData = [];
      this.$Apis.orderWorkEvaluateList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.$store.commit("setMsgAppraise", total);
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
</style>